var map = {
	"./Betfolio_logo_1.png": 58353,
	"./Betfolio_logo_2.png": 28186,
	"./Betfolio_logo_3.png": 29411,
	"./apple-touch-icon.png": 69519,
	"./fav.png": 74500,
	"./favicon-16x16.png": 13314,
	"./favicon-32x32.png": 3926,
	"./favicon.ico": 31790,
	"./logo-footer.png": 16384,
	"./logo-white-small.png": 21904,
	"./logo.png": 56062,
	"./surebety.png": 66534
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91995;